import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  CButton, CCard, CCardBody, CCol, CForm, CFormCheck, CFormFloating, CFormInput,
  CFormLabel, CInputGroup, CInputGroupText, CAlert, CSpinner, CTooltip,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
// Candado abierto/cerrado para mostrar/ocultar contraseña (aprobado
// Rafael 2026-08-25 — se reemplazó el ojo tachado por candado) + iconos del
// campo flotante (usuario/candado) — pedido Rafael 2026-10-16: igual al
// Flutter (login_screen.dart: prefixIcon person/lock + labelText flotante).
import { cilCloudDownload, cilLockLocked, cilLockUnlocked, cilUser } from '@coreui/icons'
import TroniaFab from '../components/TroniaFab'
import { login, currentUser } from '../api/client'
import { t } from '../i18n'

/**
 * Login — detalle visual del demo CoreUI Free (authentication/login),
 * lógica de SiprinialowCode (usuario/contraseña/empresa/rol). Sin social.
 * [RGM] "Mantener conectado" y recuperación de contraseña son diseño NUEVO
 * aprobado por Rafael (no existen en el login GX/LowCode).
 */
const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [remember, setRemember] = useState(false)
  // Carrusel de los 5 banners del login Flutter (banner_1..5.png)
  const [bannerIndex, setBannerIndex] = useState(0)
  useEffect(() => {
    const t = setInterval(() => setBannerIndex((i) => (i + 1) % 5), 4000)
    return () => clearInterval(t)
  }, [])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // Login — réplica del login GX (login.cs:48 ExecutePrivate) con la lógica de
  // SipriniaLowCode (usuario/contraseña/empresa/rol vía /auth/login). Los textos
  // de UI ("Iniciar sesión", "Usuario", "Contraseña") replican los captions del
  // login GX; el logo y el título SiprinIA son identidad visual aprobada.
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    // [RGM] 2026-10-16 (pedido Rafael): validación PROPIA (el form va
    // noValidate) — el globito nativo del navegador del required HTML quedaba
    // feo; acá el aviso sale con el estilo de la app (CAlert).
    if (!username.trim() || !password) {
      setError(t('Ingrese usuario y contraseña'))
      return
    }
    setLoading(true)
    try {
      const { user: u } = await login(username.trim(), password, remember)
      // [RGM] 2026-09-16 (pedido Rafael): el SUPERADMIN aterriza en su resumen
      // (/superadmin); los demás roles entran al HOME (login GX login.cs:1096-1100).
      window.location.href = u.role === 'superadmin' ? '/superadmin' : '/home'
    } catch (err: any) {
      setError(err.message ?? 'Credenciales inválidas')
    } finally {
      setLoading(false)
    }
  }

  const user = currentUser()
  if (user) {
    // [RGM] 2026-09-16 (pedido Rafael): el superadmin va a su resumen; el resto al home.
    window.location.href = user.role === 'superadmin' ? '/superadmin' : '/home'
  }

  return (
    <div className="min-vh-100 d-flex" style={{ background: 'linear-gradient(135deg, #078bcd 0%, #0a5d84 100%)' }}>
      {/* ── Panel IZQUIERDO: banner del login Flutter + marca + links
             (diseño [RGM] aprobado Rafael 2026-08-25 — azul institucional
             #078bcd; banner_*.png compartido con la app móvil) ── */}
      <div className="d-none d-lg-flex flex-column justify-content-between flex-grow-1 p-5" style={{ color: '#fff' }}>
        <div>
          <div className="d-flex align-items-center gap-3">
            <img src="/logo_siprinia.png" alt="SiprinIA" height={64} />
            <span className="fs-3 fw-bold">SiprinIA</span>
          </div>
          <h1 className="display-6 fw-bold mt-5 mb-3" style={{ maxWidth: 560 }}>
            {t('Plataforma inteligente de gestión de cobranza y administración de préstamos')}
          </h1>
          <p className="fs-6 opacity-75" style={{ maxWidth: 460 }}>
            {t('Controle su cartera, rutas, abonos y cobradores desde una sola plataforma.')}
          </p>
        </div>
        {/* Carrusel suave: las 5 imágenes apiladas con fade cross (opacity),
            SIN remount (el key causaba recarga visible y se veía feo). */}
        <div className="position-relative text-center" style={{ height: 240 }}>
          {[1, 2, 3, 4, 5].map((n) => (
            <img
              key={n}
              src={`/banners/banner_${n}.png`}
              alt="SiprinIA"
              className="position-absolute top-0 start-50 translate-middle-x img-fluid rounded-4 shadow-lg"
              style={{
                maxHeight: 240,
                objectFit: 'cover',
                opacity: bannerIndex === n - 1 ? 1 : 0,
                transition: 'opacity .6s ease',
              }}
            />
          ))}
        </div>
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <a href="https://cybertronica.com.co" target="_blank" rel="noopener noreferrer"
             className="text-white text-decoration-none small opacity-75">
            cybertronica.com.co
          </a>
          <span className="opacity-50">·</span>
          <a href="https://tronia.ai" target="_blank" rel="noopener noreferrer"
             className="text-white text-decoration-none small opacity-75">
            tronia.ai
          </a>
          <span className="opacity-50">·</span>
          <a href="https://cybertronia.com" target="_blank" rel="noopener noreferrer"
             className="text-white text-decoration-none small opacity-75">
            cybertronia.com
          </a>
          <span className="opacity-50">·</span>
          <a href="https://siprin.net" target="_blank" rel="noopener noreferrer"
             className="text-white text-decoration-none small opacity-75">
            siprin.net
          </a>
          <span className="opacity-50">·</span>
          {/* Descargar APK Cobrador: link blanco igual a los demás (el APK lo
              sirve el deploy en /siprinia-dev.apk — decisión Rafael: el mismo
              texto en el login web y el móvil). */}
          <a href="/siprinia-dev.apk" className="text-white text-decoration-none small opacity-75">
            {t('Descargar APK Cobrador')}
          </a>
        </div>
      </div>

      {/* ── Panel DERECHO: formulario de inicio de sesión ── */}
      {/* min-width:0 — el flex item con flex-grow-1 y min-width:auto crece
          con su contenido (420px + padding) y desbordaba el viewport en
          móvil (scrollWidth 468 en 320px). */}
      <div
        className="bg-body-tertiary d-flex align-items-center justify-content-center flex-grow-1 p-3 p-sm-4"
        style={{ minWidth: 0 }}
      >
        <div style={{ width: '100%', maxWidth: 420, minWidth: 0 }}>
          {/* Marca visible SOLO en móvil (< lg): en desktop vive en el panel */}
          <div className="d-lg-none text-center mb-4">
            <img src="/logo_siprinia.png" alt="SiprinIA" height={80} />
            <h1 className="h4 fw-bold mb-0 mt-2">SiprinIA</h1>
          </div>
          <CCard className="p-3 p-sm-4">
            <CCardBody className="d-flex flex-column gap-4">
              <div className="text-center">
                <h2 className="h4 fw-bold mb-1">{t('Iniciar sesión')}</h2>
                <p className="text-body-secondary small mb-0">
                  {t('Ingrese sus credenciales para acceder al sistema')}
                </p>
              </div>
              {error && <CAlert color="danger" className="mb-0">{error}</CAlert>}
              <CForm className="row gy-3" onSubmit={handleSubmit} noValidate>
                <CCol xs={12}>
                  {/* [RGM] 2026-10-16 (pedido Rafael): campo flotante con icono
                      (igual al login Flutter) — CInputGroup(icono) +
                      CFormFloating; el placeholder es " " para que NO se vea
                      texto nativo (solo flota la etiqueta). */}
                  <CInputGroup>
                    <CInputGroupText><CIcon icon={cilUser} /></CInputGroupText>
                    <CFormFloating>
                      <CFormInput
                        id="login-user"
                        type="text"
                        placeholder=" "
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete="username"
                      />
                      <CFormLabel htmlFor="login-user">{t('Usuario')}</CFormLabel>
                    </CFormFloating>
                  </CInputGroup>
                </CCol>
                <CCol xs={12}>
                  <CInputGroup>
                    <CInputGroupText><CIcon icon={cilLockLocked} /></CInputGroupText>
                    <CFormFloating>
                      <CFormInput
                        id="login-pass"
                        type={showPassword ? 'text' : 'password'}
                        placeholder=" "
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                      />
                      <CFormLabel htmlFor="login-pass">{t('Contraseña')}</CFormLabel>
                    </CFormFloating>
                    <CInputGroupText>
                      <CTooltip content={showPassword ? t('Ocultar contraseña') : t('Mostrar contraseña')}>
                        <CButton
                          type="button"
                          color="link"
                          className="p-0 link-secondary"
                          aria-label={showPassword ? t('Ocultar contraseña') : t('Mostrar contraseña')}
                          onClick={() => setShowPassword((s) => !s)}
                        >
                          <CIcon icon={showPassword ? cilLockUnlocked : cilLockLocked} size="sm" />
                        </CButton>
                      </CTooltip>
                    </CInputGroupText>
                  </CInputGroup>
                </CCol>
                <CCol xs={12} className="d-flex justify-content-between align-items-center gap-1 flex-nowrap">
                  {/* Recordarme (izq) y ¿Olvidaste? (der): SIEMPRE en la misma
                      fila — letra más pequeña (0.78rem) para que quepa en
                      móvil sin desbordar (pedido Rafael 2026-08-26). */}
                  <CFormCheck
                    id="login-remember"
                    label={t('Recordarme')}
                    className="text-nowrap"
                    style={{ fontSize: '0.75rem' }}
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                  />
                  <Link to="/recuperar-clave" className="text-decoration-none text-nowrap" style={{ fontSize: '0.8rem' }}>
                    {t('¿Olvidó su Contraseña?')}
                  </Link>
                </CCol>
                <CCol xs={12}>
                  <CButton color="primary" type="submit" disabled={loading} className="w-100">
                    {loading ? <CSpinner size="sm" /> : t('Iniciar sesión')}
                  </CButton>
                </CCol>
                <CCol xs={12} className="text-center">
                  {/* [RGM] Registro público (diseño nuevo aprobado — el GX no
                      tiene registro self-service en la web) */}
                  <small className="text-body-secondary">
                    {t('¿No tienes cuenta?')}{' '}
                    <Link to="/register" className="text-decoration-none fw-semibold">
                      {t('Registrarse')}
                    </Link>
                  </small>
                </CCol>
              </CForm>
            </CCardBody>
          </CCard>
          {/* Descargar APK Cobrador — SOLO móvil (< lg), debajo de la tarjeta:
              en desktop vive en el panel izquierdo. Misma URL /siprinia-dev.apk
              (dev y main la sirven — pedido Rafael 2026-10-04: visible en el
              teléfono para descargar desde ahí). */}
          <div className="d-lg-none text-center mt-3">
            <a href="/siprinia-dev.apk" className="text-decoration-none small text-body-secondary">
              <CIcon icon={cilCloudDownload} size="sm" className="me-1" />
              {t('Descargar APK Cobrador')}
            </a>
          </div>
        </div>
      </div>
      {/* TronIA pública del Login (Fase 1 — chat sin sesión, [RGM]) */}
      <TroniaFab mode="public" />
    </div>
  )
}

export default LoginPage
